
import { useState, useEffect } from 'react';
import { BirdieGameGroup } from "@/types";
import { getGames } from "@/integrations/supabase/game";
import { toast } from "@/hooks/use-toast";

export const useHomeGames = (userId: string | undefined, refetchKey: number = 0) => {
  const [userGames, setUserGames] = useState<BirdieGameGroup[]>([]);
  const [isLoadingGames, setIsLoadingGames] = useState(true);

  useEffect(() => {
    const fetchUserGames = async () => {
      if (!userId) return;

      try {
        setIsLoadingGames(true);
        const games = await getGames();
        setUserGames(games);
      } catch (error) {
        console.error("useHomeGames - Error fetching user games:", error);
        toast({
          title: "Error fetching games",
          description: "There was an error loading your games. Please try again later.",
          variant: "destructive",
        });
      } finally {
        setIsLoadingGames(false);
      }
    };

    fetchUserGames();
  }, [userId, refetchKey]);

  return {
    userGames,
    isLoadingGames
  };
};
